<template>
  <div class="vipProductList-box">
    <div class="previewsbox flex just-center" v-if="filterTableList && filterTableList.length > 0">
      <ul class="flex ">
        <li v-for="(item,index) in filterTableList" :key="index" class="pitem">
          <div class="flex just-center  align-item-center">
            <img-load
                height="30px"
                v-if="showImgLoad && item.img"
                :src="imgUrl + '/' + item.img"
            ></img-load>
            <div class="ml-10">
              <div class="fz12">{{item.name}}</div>
              <div class="fz11">{{item.desc}}</div>
              <div class="fz10">花费{{item.price}}积分</div>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <!--操作栏-->
    <div class="action-bar">
      <el-button
        type="primary"
        size="small"
        @click="handleOpenEdit('add', tableData)"
        class="add-input"
        >+新增</el-button
      >
      <el-button
          type="primary"
          size="small"
          @click="handleQuery()"
          class="add-input"
      >刷新</el-button
      >
    </div>
    <!--数据表格-->
    <el-table
      :data="tableData"
      border
      size="small"
      v-loading="loading"
      height='620'
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
    >
      <el-table-column  label="序列" align="center" width="60">
        <template slot-scope="scope">
          {{scope.$index+1}}
        </template>
      </el-table-column>
      <el-table-column label="ID" align="center" prop="id"  ></el-table-column>
      <el-table-column prop="word" label="关键词" align="center" ></el-table-column>
      <el-table-column prop="count" label="搜索次数" align="center" ></el-table-column>
      <el-table-column prop="createdAt" label="创建时间" align="center">
        <template slot-scope="scope">
          <span>{{scope.row.createdAt | changeDate}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="updatedAt" label="更新时间" align="center">
        <template slot-scope="scope">
          <span>{{scope.row.updatedAt | changeDate}}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button
            type="success"
            size="mini"
            icon="el-icon-edit"
            @click="handleOpenEdit('edit', scope.row)"
          ></el-button>
          <el-button
            type="danger"
            size="mini"
            icon="el-icon-delete"
            @click="handleRemove(scope.row)"
          ></el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--新增、编辑弹框-->
    <addedit
      ref="positionAction"
      @callback="handlerList"
    ></addedit>
  </div>
</template>
<script>
import API from "@/api/hottag";
import addedit from "./components/addedit";
import baseConfig from "@/utils/serverUrlConfig";

export default {
  data() {
    return {
      // 表格数据加载动画
      loading: false,
      imgUrl: baseConfig.imgUrl,
      showImgLoad: false,
      tableData: [],
      // 列表请求参数
      params: {
        status: -1,
      },
    };
  },
  components: {
    addedit,
  },
  created() {
    this.handlerListMain(this.params);
  },
  computed:{
    filterTableList(){
      return this.tableData.filter(c=>c.status == 1).sort((a,b)=>a.sorted - b.sorted)
    }
  },
  methods: {
    // 请求商品列表
    handlerListMain() {
      this.loading = true;
      API.list(this.params)
        .then((res) => {
          this.showImgLoad = true;
          if (res.code === 200 && res.data.length > 0) {
            this.tableData = res.data;
          }
          this.loading = false;
        })
        .catch(() => {
          this.showImgLoad = false;
          this.loading = false;
        });
    },

    handleQuery(){
      this.handlerListMain()
    },

    // 监听编辑、或者添加成功过后重新拉去数据
    handlerList() {
      this.handlerListMain();
    },

    // 快速修改值
    handlerField(field,index,flag) {
      var id = this.tableData[index].id
      var value = this.tableData[index][field]
      if(flag)value = parseInt(value)
      API.field({id:id,field:field,value:value}).then(res=>{
        if (res.code === 200) {
          this.$message({
            message: "修改成功",
            type: "success",
          });
          this.handlerListMain();
        } else {
          this.$message.error("复制失败！");
        }
      })
    },

    // 快速复制
    handlerCopy(id) {
      API.copy({id:id}).then(res=>{
        if (res.code === 200) {
          this.$message({
            message: "复制成功",
            type: "success",
          });
          this.handlerListMain();
        } else {
          this.$message.error("复制失败！");
        }
      })
    },
    // 删除管理员
    handleRemove(row) {
      API.remove({ id: row.id }).then((res) => {
        if (res.code === 200) {
          this.$message({
            message: "删除成功",
            type: "success",
          });
          this.handlerListMain();
        } else {
          this.$message.error("删除失败！");
        }
      });
    },
    // 新增、编辑操作
    handleOpenEdit(type, data) {
      if(type == 'add')data.sorted = this.tableData.length + 1
      this.$refs.positionAction.open(type, data);
    },
  },
};
</script>

<style scoped lang="scss">
.vipProductList-box {
  display: flex;
  height: 100%;
  flex-direction: column;
}
.previewsbox{
  background:#eee;
  padding:20px 10px;
  border-radius: 4px;
  margin: 5px 0;
  min-height: 100px;
  .pitem{
    margin: 0 10px;
    font-size:11px;
    padding:10px;
    background-color: #ffab00;
    display: flex;
    border-radius: 10px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    font-weight: 1000;
    &:hover{
      color:#fff;
    }
  }
}
</style>
